import React, { useState, createRef, useEffect } from 'react';
import { formsCusInfoDataChange } from '../stores/loginSlice';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames/bind';

const regexForReplace = Object.freeze({
    thaiEngWithSpace: /[^A-Za-z\u0E01-\u0E3A\u0E40-\u0E4D\s]/g,
    numberOnly: /[^0-9]/g,
    emojiRegEx: /([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2694-\u2697]|\uD83E[\uDD10-\uDD5D])/g,

})

const $ = window.$

export class SelectList extends React.Component {
    constructor(props) {
        super(props);
        if (this.props.className) {
            this.className = this.props.className
        } else {
            this.className = "select-field mb-3"
        }

        if (this.props.templateSelection) {
            this.templateSelection = this.props.templateSelection
        } else {
            this.templateSelection = ""
        }

        this.minimumResultsForSearch = this.props.minimumResultsForSearch;

        // console.log("select name",this.className)
        this.handleChange = this.handleChange.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
    }

    handleChange(e) {
        // console.log(e)
        this.props.OnformsDataChange({ field: this.props.fieldName, value: e.params.args.data.id });
        e.preventDefault();
        this.$el.select2('close');
    }

    handleOpen() {
        console.log("this.props.placeholderSearch", this.props.placeholderSearch)
        $("input.select2-search__field").prop("placeholder", this.props.placeholderSearch);
    }

    componentDidMount() {
        //const props = this.props
        this.$el = $(this.el);

        if (this.$el.data('select2')) {
            this.$el.select2('destroy');
        }

        this.select2Setting = {
            placeholder: this.props.placeholder,
            allowClear: true,
            //onChange: this.handleChange
        }

        if (this.props.dropdownParent) {
            this.select2Setting.dropdownParent = $(this.props.dropdownParent)
        }

        if (this.props.templateSelection) {
            this.select2Setting.templateSelection = this.props.templateSelection
        }

        if (this.props.minimumResultsForSearch) {
            this.select2Setting.minimumResultsForSearch = this.props.minimumResultsForSearch
        }

        // console.log(this.select2Setting)
        this.$el
            .select2(this.select2Setting)
            .one("select2:open", this.handleOpen)
            .on('select2:selecting', this.handleChange)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.option !== this.props.option) {
            this.$el.select2('destroy');
            this.$el.select2(this.select2Setting
                //     {
                //     placeholder: this.props.placeholder,
                //     allowClear: true,
                //     //onChange: this.handleChange
                // }
            )
                .one("select2:open", this.handleOpen)
                .on('select2:selecting', this.handleChange)
            // console.log(`SelectList ${this.props.fieldName} Updated`)
        }
        if (prevProps.value !== this.props.value) {
            this.$el.trigger('change.select2');
        }
    }

    renderChild(item, index) {
        return <option key={item.value} value={item.value} title={item.title}>{item.text}</option>
    }

    render() {
        return <div className={this.className}>
            <select name={this.props.id} id={this.props.id} value={this.props.value} ref={el => this.el = el} readOnly>
                {!this.props.notShowEmptyOption && <option></option>}
                {Array.isArray(this.props.option) && this.props.option.map((item, index) => this.renderChild(item, index))}
            </select>
        </div>;

    }
}

export class IonRange extends React.Component {
    constructor(props) {
        super(props);
        //this.formsDataChange = props.formsDataChange;
        //this = props;
        // Don't call this.setState() here!
        // this.state = { counter: 0 };
        // this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(data) {
        this.props.OnformsDataChange(this.props.fieldName, data.from_value, (new Set([data.from, data.to, data.max]).size === 1) ? "" : data.to_value);
    }

    componentDidMount() {
        //const props = this.props
        // console.log(this.props, " <--slider value");
        this.$el = $(this.el);
        this.$el.ionRangeSlider({
            skin: "big",
            type: "double",
            grid: false,
            min: this.props.min,
            max: this.props.max,
            from: this.props.from,
            to: this.props.to,
            step: this.props.step,
            values: this.props.values,
            hide_from_to: true,
            hide_min_max: true,
            // skin: "round",
            // prettify_separator: ",",
            //onChange: this.handleChange
            onFinish: this.handleChange
        });
    }

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if (this.props.max !== prevProps.max
            || this.props.min !== prevProps.min
            || this.props.step !== prevProps.step
            || this.props.count !== prevProps.count) {
            this.$el.data("ionRangeSlider").update({
                min: this.props.min,
                max: this.props.max,
                step: this.props.step,
                from: this.props.from,
                to: this.props.to,
            });
        }
    }

    componentWillUnmount() {
        this.$el.data("ionRangeSlider").destroy();
    }

    render() {
        return <div className="rangeSlider-field">
            <input ref={el => this.el = el} />
        </div>;
    }
}

export const RangeInput = (props) => {
    const [Start, setStartValue] = useState("");
    const [End, setEndValue] = useState("");
    const [StartList, setStartListValue] = useState(props.values);
    const [EndList, setEndListValue] = useState(props.values);
    const dropdown = createRef();

    useEffect(() => {
        calcHeight();
    })

    function clickRangeInput(e) {
        if ($(".range-dropdown.active").length > 0) {
            $(".range-dropdown.active").removeClass("active");
        }
        $(dropdown.current).addClass('active')
        setStart()
    }

    function calcHeight() {
        var that = dropdown.current;

        var heightDropDown = $(that).innerHeight();
        var heightPopup = $('.mfp-content').innerHeight() - 30;
        var positionDropdDown = $(that).parents().position().top;
        var addTop = 8;
        var newPositionDropDown = heightDropDown + addTop;

        if ((positionDropdDown + heightDropDown) > heightPopup) {
            $(that).css("top", "-" + newPositionDropDown + "px");
        } else if (parseFloat($(that).css("top")) < 0) {
            $(that).css("top", "-" + newPositionDropDown + "px");
        }
    }

    function setStart() {
        $(dropdown.current).addClass('start')
        $(dropdown.current).removeClass('end')
        calcHeight();
    }

    function setEnd() {
        $(dropdown.current).addClass('end')
        $(dropdown.current).removeClass('start')
    }

    function startClick(item) {
        // console.log("start",item)
        setStartValue(item)
        const index = StartList.indexOf(item)
        if (index > 0) {
            setEndListValue(StartList.slice(0, 1).concat(StartList.slice(StartList.indexOf(item) + 1)))
        } else {
            setEndListValue(StartList)
        }
        props.OnformsDataChange(props.fieldName, item, "")
        setEnd();
    }

    function endClick(item) {
        // console.log("end",item)
        setEndValue(item)
        props.OnformsDataChange(props.fieldName, Start, item)
        $(dropdown.current).removeClass('active')
    }

    function renderStartChild(item, index) {
        return <li key={index} value={item} onClick={e => startClick(item)}>{item}</li>
    }

    function renderEndChild(item, index) {
        return <li key={index} value={item} onClick={e => endClick(item)}>{item}</li>
    }

    return (<div className="rangeInput-wrap">
        <input id="price-range-text" type="text" className="normal-input" name="price-range-text" placeholder={props.placeholder} readOnly onClick={clickRangeInput} value={props.value} />
        <div className={classnames(["range-dropdown"])} ref={dropdown}>
            <div className="range-header">
                <div className="range-btn start" onClick={setStart}>เริ่มต้น</div>
                <div>-</div>
                <div className="range-btn end" onClick={setEnd}>สิ้นสุด</div>
            </div>
            <div className="range-body">
                <ul className="option-list start">
                    {StartList.map((item, index) => renderStartChild(item, index))}
                </ul>
                <ul className="option-list end">
                    {EndList.map((item, index) => renderEndChild(item, index))}
                </ul>
            </div>
        </div>
    </div>)
}

export const CheckBoxIonInput = (props) => {

    function check() {
        props.OnformsDataChange(props.fieldName, !props.value, props.group)
    }

    return (
        <>
            <input type="checkbox" name="property-type" checked={props.value} hidden readOnly />
            <label className="radio-item" onClick={check}>
                <div className="custom-check-icon"></div>
                <i className={`ic-npa ic-npa-icon-${props.fieldName}`}></i>
            </label>
            <p>{props.name}</p>
        </>)
}

export const LoginInputField = (props) => {

    const dispatch = useDispatch()

    const [customerInfo] = useSelector((state) => [
        state.login.customerInfo,
    ])

    function OnformsDataChange(e) {
        CustomerInfoDataChange(props.fieldName, e.target.value);
        // props.OnformsDataChange(props.fieldName, e.target.value);

    }

    function OnformsBlur(e) {
        CustomerInfoBlur(props.fieldName, e.target.value);
        props.formsBlur && props.formsBlur(props.fieldName, e.target.value);
    }

    function CustomerInfoDataChange(field, value) {

        let errorMessage = ""
        switch (field) {
            case 'otp':
                errorMessage = VaridateCustomerDataField(field, value);
            case 'phone':
                value = value.replace(regexForReplace.numberOnly, '')
                value = value.slice(0, 10);
                break;
            case 'fullName':
                value = value.replace(regexForReplace.thaiEngWithSpace, '')
                break;
            case 'email':
            default:
                break;
        };

        // console.log('on change', field, value, errorMessage);
        dispatch(formsCusInfoDataChange({ field, value, errorMessage }))

        if (props.validateField && props.setSubmitEnable) {
            const validates = props.validateField.map(x => {
                let errMsg = customerInfo[x].errorMessage
                if (x === field) {
                    errMsg = errorMessage;
                }
                const result = customerInfo[x].value && !errMsg;
                return result;
            });
            const valid = validates.every(c => c);

            props.setSubmitEnable(valid);
        }
    }

    function CustomerInfoBlur(field, value) {
        value = (value || "").trim();
        const errorMessage = VaridateCustomerDataField(field, value);

        console.log('on blur', field, value, errorMessage)
        dispatch(formsCusInfoDataChange({ field, value, errorMessage }))

        if (props.validateField && props.setSubmitEnable) {
            const validates = props.validateField.map(x => {
                let errMsg = customerInfo[x].errorMessage
                if (x === field) {
                    errMsg = errorMessage;
                }
                const result = customerInfo[x].value && !errMsg;
                return result;
            });
            const valid = validates.every(c => c);

            props.setSubmitEnable(valid);
        }
    }

    function VaridateCustomerDataField(field, value) {
        if (typeof (value) == 'boolean') {
            value = value.toString()
        }

        const formDataField = customerInfo[field];
        if (formDataField.required) {
            switch (field) {
                case 'fullName':
                    if (value === '') {
                        return 'กรุณากรอกชื่อ-นามสกุล';
                    } else if (!isThaiEngNonNumber(value)) {
                        return 'กรอกข้อมูลชื่อ-นามสกุลให้ถูกต้อง';
                    }

                    return '';
                case 'phone':
                    if (value === '') {
                        return 'กรุณากรอกเบอร์โทรศัพท์';
                    } else if (!IsValidMobilePhone(value) || !/^0[869]/.test(value)) {
                        return 'กรอกข้อมูลเบอร์โทรศัพท์ให้ถูกต้อง';
                    }

                    return '';
                case 'otp':
                    if (value === '') {
                        return 'กรุณากรอก OTP';
                    }
                    else if (value.length !== 6) {
                        return 'กรอกข้อมูล OTP ให้ถูกต้อง';
                    }

                    return '';
                case 'email':
                    if (value === '') {
                        return 'กรุณากรอกอีเมล';
                    } else if (!IsValidEmail(value)) {
                        return 'กรอกข้อมูลอีเมลให้ถูกต้อง';
                    }

                    return '';
                default:
                    return '';
            }
        }
        else {
            return '';
        }
    }

    return (
        <div className={classnames(["wrap-input", { "valid": props.errorMessage }])}>
            <div className="label-input">{props.label ? props.label : ''}{props.required && <span className="c-red">*</span>}</div>
            <div className="box-input">
                <input className="input"
                    placeholder={props.placeholder}
                    value={props.value}
                    onChange={OnformsDataChange}
                    onBlur={OnformsBlur}
                    maxLength={props.maxLength}
                    inputMode={props.inputmode} 
                    onKeyDown={props.onKeyDown}
                    />
                {props.additionBtn && props.additionBtn}
                {/* <button className="btn-plus request-otp">Request OTP</button> */}
            </div>
            {props.errorMessage && <div className="valid-msg win">{props.errorMessage}</div>}
        </div>
    );
}

export const RequestOtpBtn = (props) => {
    function handleOnClick(e) {
        props.onClick && props.onClick(e);
    }

    return (
        <button className="btn-plus request-otp" onClick={handleOnClick}>Request OTP</button>
    );
}

var thaiEngNonNumberRegEx = /^[A-Za-z\u0E00-\u0E5F_-\s]*$/;

function isThaiEngNonNumber(str) {
    return thaiEngNonNumberRegEx.test(str);
}

function IsValidEmail(email) {
    // the regex works in IE but should be a string (see nnnnn's answer) 
    // var em= new RegExp(/^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i);
    var em = /^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i; // simpler
    return em.test(email);
}

function IsValidMobilePhone(phonenumber) {
    return /0[13456789]{1}[0-9]{8}$/.test(phonenumber)// && /^0[869]/.test(phonenumber);
}

function IsNumberOnly(str) {
    return /[0123456789]$/.test(str)
}

export function valueRangeMaxMin(fieldName, from, to) {

    let value = ""
    if (from === "ไม่ระบุ" && to === "ไม่ระบุ") {
        value = ""
    } else if (from === "ไม่ระบุ" || from === "") {
        value = "สูงสุด " + to
    } else if (to === "ไม่ระบุ" || to === "") {
        value = "เริ่มต้น " + from
        to = "MAX"
    }
    else {
        value = `${from} - ${to}`
    }

    return { fieldName, value, from, to }
}

export function mtCustomerSubscribeToPayload(MtCustomerSubscribe) {
    let rangePrice = MtCustomerSubscribe.MIN_PRICE
    if (MtCustomerSubscribe.MAX_PRICE != 0 && MtCustomerSubscribe.MAX_PRICE) {
        rangePrice += "," + MtCustomerSubscribe.MAX_PRICE
    }
    let areaRange = MtCustomerSubscribe.MIN_AREA
    if (MtCustomerSubscribe.MAX_AREA != 0 && MtCustomerSubscribe.MAX_AREA) {
        areaRange += "," + MtCustomerSubscribe.MAX_AREA
    }
    let useableAreaRange = MtCustomerSubscribe.MIN_USEABLE_AREA
    if (MtCustomerSubscribe.MAX_USEABLE_AREA != 0 && MtCustomerSubscribe.MAX_USEABLE_AREA) {
        useableAreaRange += "," + MtCustomerSubscribe.MAX_USEABLE_AREA
    }
    const payload = {
        customerSubscribeId: MtCustomerSubscribe.CUSTOMER_SUBSCRIBE_ID,
        criteriaName: MtCustomerSubscribe.CRITERIA_NAME,
        province: MtCustomerSubscribe.PROVINCE,
        district: MtCustomerSubscribe.AMPHUR,
        subDistrict: MtCustomerSubscribe.TAMBON,
        propertyType: MtCustomerSubscribe.PROPERTY_TYPES,
        rangePrice: rangePrice,
        areaRange: areaRange,
        useableAreaRange: useableAreaRange,
        frequency: MtCustomerSubscribe.FREQUENCY,
    }
    return payload;
}

export function mtCustomerSubscribeRequestToPayload(MtCustomerSubscribe) {
    let rangePrice = MtCustomerSubscribe.MinPrice
    if (MtCustomerSubscribe.MaxPrice != 0 && MtCustomerSubscribe.MaxPrice) {
        rangePrice += "," + MtCustomerSubscribe.MaxPrice
    }
    let areaRange = MtCustomerSubscribe.MinArea
    if (MtCustomerSubscribe.MaxArea != 0 && MtCustomerSubscribe.MaxArea) {
        areaRange += "," + MtCustomerSubscribe.MaxArea
    }
    let useableAreaRange = MtCustomerSubscribe.MinUseableArea
    if (MtCustomerSubscribe.MaxUseableArea != 0 && MtCustomerSubscribe.MaxUseableArea) {
        useableAreaRange += "," + MtCustomerSubscribe.MaxUseableArea
    }
    const payload = {
        customerSubscribeId: MtCustomerSubscribe.CustomerSubscribeId,
        criteriaName: MtCustomerSubscribe.CriteriaName,
        province: MtCustomerSubscribe.Province,
        district: MtCustomerSubscribe.Amphur,
        subDistrict: MtCustomerSubscribe.Tambon,
        propertyType: MtCustomerSubscribe.PropertyTypes,
        rangePrice: rangePrice,
        areaRange: areaRange,
        useableAreaRange: useableAreaRange,
        frequency: MtCustomerSubscribe.Frequency,
    }
    return payload;
}

export function replaceStrThaiEngWithSpace(value) {
    return value.replace(regexForReplace.thaiEngWithSpace, '');
}
